import {
  SET_FONTS,
  SET_FONT_SIZE,
  LOCK_PRIMARY_FONT,
  LOCK_SECONDARY_FONT
} from '../actions/fonts';

export const fonts = (state = {}, action) => {
  switch (action.type) {
    case SET_FONTS:
      return action.fonts
    default:
      return state
  }
}

export const fontSize = (state = 16, action) => {
  switch (action.type) {
    case SET_FONT_SIZE:
      return action.size
    default:
      return state
  }
}

export const lockedPrimary = (state = '', action) => {
  switch (action.type) {
    case LOCK_PRIMARY_FONT:
      return action.name
    default:
      return state
  }
}

export const lockedSecondary = (state = '', action) => {
  switch (action.type) {
    case LOCK_SECONDARY_FONT:
      return action.name
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/fonts.js